import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Dropdown} from 'antd';
import { StyledVendorStatusSelector } from './StyledVendorStatusSelector';
import {vendorsHelpers, VendorStatusesOptions} from '../../../../utils/helpers';

const VendorStatusSelector = ({
  onChange,
  vendor,
  ...rest
}) => {
  const [statusOptions, ] = useState(VendorStatusesOptions(true));

  const status = vendor?.status;

  const items = statusOptions
    .filter(item => item.value !== status)
    .map(({value}) => ({key: value, label: vendorsHelpers.getVendorStatusMark({status: value})}));

  const onMenuItemClick = ({domEvent, key}) => {
    onChange && onChange(key, domEvent);
  }

  return (
    <StyledVendorStatusSelector {...rest}>
      <Dropdown menu={{items, onClick: onMenuItemClick}}>
        <span>{vendorsHelpers.getVendorStatusMark({status})}</span>
      </Dropdown>
    </StyledVendorStatusSelector>
  );
}

VendorStatusSelector.propTypes = {
  vendor: PropTypes.shape({
    status: PropTypes.number
  }),
}

export default VendorStatusSelector;
